import { Component, forwardRef, signal, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'app-lieux-autocomplete',
	templateUrl: './lieux-autocomplete.component.html',
	styleUrls: ['./lieux-autocomplete.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => LieuxAutocompleteComponent),
			multi: true
		}
	]
})
export class LieuxAutocompleteComponent implements ControlValueAccessor {
	// Inputs
	suggestions = input<string[]>([]);

	// Signaux
	lieuxCherches = signal<string[]>([]);

	// Variables
	valeur: string[] = [];
	desactive = false;

	/**
	 * Fonction appelée à chaque changement de valeur, enregistrée par Angular via {@link registerOnChange}.
	 * Prévenir le FormControl parent que la valeur a changé.
	 *
	 * @param valeur la nouvelle valeur sélectionnée.
	 */
	private onChange: (valeur: string[]) => void = (valeur: string[]) => {
		this.valeur = valeur;
	};

	/**
	 * Fonction appelée pour marquer le contrôle comme touché, enregistrée par Angular via {@link registerOnTouched}.
	 */
	private onTouched: () => void = () => {
	};

	/**
	 * Appelée par Angular pour initialiser ou réinitialiser la valeur du composant (ex: setValue ou reset sur le FormControl parent).
	 *
	 * @param valeur la valeur à écrire dans le composant.
	 */
	writeValue(valeur: string[]): void {
		this.valeur = valeur ?? [];
	}

	/**
	 * Enregistre la fonction à appeler lorsque la valeur du composant change.
	 *
	 * @param fn la fonction de callback fournie par Angular.
	 */
	registerOnChange(fn: (valeur: string[]) => void): void {
		this.onChange = fn;
	}

	/**
	 * Enregistre la fonction à appeler lorsque le composant est touché (perte de focus).
	 *
	 * @param fn la fonction de callback fournie par Angular.
	 */
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	/**
	 * Appelée par Angular lorsque l'état désactivé du FormControl associé change.
	 *
	 * @param isDisabled true si le contrôle doit être désactivé.
	 */
	setDisabledState(isDisabled: boolean): void {
		this.desactive = isDisabled;
	}

	/**
	 * Met à jour la valeur sélectionnée par l'utilisateur et notifie le formulaire parent du changement et du fait que le champ a été touché.
	 *
	 * @param valeur la nouvelle valeur sélectionnée.
	 */
	onValeurChange(valeur: string[]): void {
		this.valeur = valeur;
		this.onChange(valeur);
		this.onTouched();
	}

	/**
	 * Filtre les suggestions de lieux en fonction de la saisie de l'utilisateur.
	 *
	 * @param event l'événement de saisie contenant la requête de recherche.
	 */
	completeMethodLieu(event: { query: string }): void {
		const query = event.query;

		this.lieuxCherches.set(
			this.suggestions().filter(item => item.toLowerCase().includes(query.toLowerCase()))
		);
	}
}